// extracted by mini-css-extract-plugin
module.exports = {"inventoryViewerHeader":"InventoryViewerHeader__inventoryViewerHeader___riFD0"};